import { AuthProviderProps, User, UserManager } from 'oidc-react';
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

const AppConsts = {
  userManagement: {
    defaultAdminUserName: 'admin',
  },
  localization: {
    defaultLocalizationSourceName: 'DigitalLogisticSystem',
  },
  authorization: {
    encrptedAuthTokenName: 'enc_auth_token',
  },
  appBaseUrl: process.env.REACT_APP_APP_BASE_URL,
  remoteServiceBaseUrl: process.env.REACT_APP_REMOTE_SERVICE_BASE_URL,
  /**
   * 可选：建单成功后跳转 URL 模板（覆盖默认 soi/moi placeAnOrder）。
   * 占位符：{cartId}、{cartType}、{orderFormId}、{orderNo}。
   */
  orderCenterFeeCartUrl: process.env.REACT_APP_ORDER_CENTER_FEE_CART_URL,
};

// Oidc.Log.logger = window.console;
// Oidc.Log.level = Oidc.Log.DEBUG;
const authority = process.env.REACT_APP_AUTHORITY;
// Keycloak 标准端点：静态下发 metadata，避免 Firefox 在跨域 discovery fetch 被中断时
// 产生未捕获的 NetworkError（发现请求已 200 后仍被 NS_BINDING_ABORTED 取消）。
// 端点路径为 Keycloak realm 的固定标准路径；不同环境只通过 authority 切换。
const oidcMetadata = authority
  ? {
      issuer: authority,
      authorization_endpoint: `${authority}/protocol/openid-connect/auth`,
      token_endpoint: `${authority}/protocol/openid-connect/token`,
      userinfo_endpoint: `${authority}/protocol/openid-connect/userinfo`,
      end_session_endpoint: `${authority}/protocol/openid-connect/logout`,
      jwks_uri: `${authority}/protocol/openid-connect/certs`,
      check_session_iframe: `${authority}/protocol/openid-connect/login-status-iframe.html`,
    }
  : undefined;
const userManagerConfig: UserManagerSettings = {
  // 其他配置项...
  automaticSilentRenew: true, // 启用自动刷新令牌功能
  authority: authority,
  metadata: oidcMetadata,
  client_id: process.env.REACT_APP_CLIENTID,
  redirect_uri: `${process.env.REACT_APP_APP_BASE_URL}/account/callback`,
  // 静默续期不要占用登录回调地址，否则会和登录回调互相干扰导致重定向循环
  silent_redirect_uri: `${process.env.REACT_APP_APP_BASE_URL}/account/slientcallback`,
  post_logout_redirect_uri: `${process.env.REACT_APP_APP_BASE_URL}/`,
  response_type: 'code',
  scope: 'openid',
  loadUserInfo: true, //千万不要赋值为false,否则不自动赋值 abp.auth
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
export const userManager: UserManager = new UserManager(userManagerConfig);
userManager.events.addUserLoaded((user) => {
  const tokenExpireDate = new Date(user.expires_at * 1000);
  abp.auth.setToken(user.access_token, tokenExpireDate);
});
function resolvePostLoginUrl(): string {
  const returnUrl = sessionStorage.getItem('returnUrl');
  sessionStorage.removeItem('returnUrl');
  if (
    !returnUrl ||
    returnUrl.indexOf('/account/callback') >= 0 ||
    returnUrl.indexOf('/account/slientcallback') >= 0
  ) {
    return '/dashboard';
  }
  try {
    const u = new URL(returnUrl, window.location.origin);
    if (u.origin !== window.location.origin) {
      return '/dashboard';
    }
    return `${u.pathname}${u.search}${u.hash}` || '/dashboard';
  } catch {
    return '/dashboard';
  }
}

export const oidcConfig: AuthProviderProps = {
  onSignIn: (user: User) => {
    if (user && !user.expired) {
      // 防止 onSignIn 被反复调用导致整页重定向死循环
      if (sessionStorage.getItem('oidc_signin_handled') === user.access_token) {
        return;
      }
      sessionStorage.setItem('oidc_signin_handled', user.access_token);
      localStorage.setItem('firstLogin', 'true');
      const tokenExpireDate = new Date(user.expires_at * 1000);
      abp.auth.setToken(user.access_token, tokenExpireDate);
      const target = resolvePostLoginUrl();
      if (`${window.location.pathname}${window.location.search}` !== target) {
        window.location.href = target;
      }
    }
  },
  authority: authority,
  metadata: oidcMetadata,
  clientId: process.env.REACT_APP_CLIENTID,
  redirectUri: `${process.env.REACT_APP_APP_BASE_URL}/account/callback`,
  userManager: userManager,
  // autoSignIn: true,
  // silentRedirectUri: `${process.env.REACT_APP_APP_BASE_URL}/account/sclientCallback`,
  // scope: "all",
  // automaticSilentRenew: true
};

export default AppConsts;
